<cc-sub-nav-on-lobby-type
    [lobbyType]="lobbyType"
    [categoryRoute]="categoryRoute"
    [lobbyProduct]="casinoProduct"
    [stickyInputQueryElement]="stickyInputQueryElement"></cc-sub-nav-on-lobby-type>
